/* Arctic Elegance motion layer: hero entrance, image reveals, gentle parallax.
   Skipped entirely when the visitor prefers reduced motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches) return;

  var root = document.documentElement;
  root.classList.add('ae-motion');

  var REVEAL = '.category-card__media, .split-collections__media, .editorial-split__media, .complete-look__media';
  var RISE = '.brand-intro__text, .editorial-banner__content, .editorial-split__text';
  var PARALLAX = '.hero__media picture, .editorial-banner__media picture';

  function init(scope) {
    scope = scope || document;

    scope.querySelectorAll('.hero').forEach(function (hero) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { hero.classList.add('is-ae-in'); });
      });
    });

    // Reveal on scroll using layout checks (reliable inside the theme editor's iframes too).
    var pending = [];
    scope.querySelectorAll(REVEAL).forEach(function (el) { el.classList.add('ae-reveal'); pending.push(el); });
    scope.querySelectorAll(RISE).forEach(function (el) { el.classList.add('ae-rise'); pending.push(el); });
    var checking = false;
    function check() {
      checking = false;
      var limit = window.innerHeight * 0.9;
      pending = pending.filter(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < limit && r.bottom > 0) {
          el.classList.add('is-ae-in');
          setTimeout(function () { el.classList.add('is-ae-done'); }, 1700);
          return false;
        }
        return true;
      });
      if (!pending.length) window.removeEventListener('scroll', onScroll);
    }
    function onScroll() { if (!checking) { checking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    requestAnimationFrame(check);

    // Parallax only on larger screens with a fine pointer, to protect mobile scrolling.
    if (!window.matchMedia('(min-width: 990px) and (pointer: fine)').matches) return;
    var layers = Array.prototype.slice.call(scope.querySelectorAll(PARALLAX));
    if (!layers.length) return;
    layers.forEach(function (el) { el.setAttribute('data-ae-parallax', ''); });
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      layers.forEach(function (el) {
        var box = el.parentElement.getBoundingClientRect();
        if (box.bottom < 0 || box.top > vh) return;
        var progress = (box.top + box.height / 2 - vh / 2) / (vh + box.height); // -0.5..0.5
        el.style.transform = 'translate3d(0,' + (progress * -5).toFixed(2) + '%,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor: re-run on sections that are re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();